import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Open Chat Controls icon — capital "A" glyph with underline.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const OpenChatControlsIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3C10.3081 3 10.583 3.19371 10.6867 3.48391L13.1114 10.2734C13.1154 10.2839 13.1193 10.2946 13.1228 10.3053L14.3323 13.6921C14.4678 14.0713 14.2701 14.4885 13.8909 14.624C13.5117 14.7594 13.0945 14.5618 12.959 14.1826L11.9166 11.2637H8.08339L7.04099 14.1826C6.90555 14.5618 6.48833 14.7594 6.1091 14.624C5.72987 14.4885 5.53224 14.0713 5.66768 13.6921L6.87719 10.3053C6.88075 10.2946 6.88455 10.2839 6.88859 10.2734L9.31334 3.48391C9.41698 3.19371 9.69186 3 10 3ZM8.6042 9.80544H11.3958L10 5.89709L8.6042 9.80544Z"
      fill="currentColor"
    />
    <path
      d="M15.334 17C15.61 17.0002 15.834 17.224 15.834 17.5C15.834 17.776 15.61 17.9998 15.334 18H4.66699C4.39085 18 4.16699 17.7761 4.16699 17.5C4.16699 17.2239 4.39085 17 4.66699 17H15.334Z"
      fill="currentColor"
    />
  </svg>
);

export default OpenChatControlsIcon;
